export const creditPointListingGet = (data) => {
    return data.data;
}